import React from 'react';
import MCQGame from './MCQGame';
import FlashcardAssess from './FlashcardAssess';
import MemoryMatch from './MemoryMatch';
import WordScramble from './WordScramble';
import FillInBlank from './FillInBlank';

// Non-MCQ games — Phase 2 will collapse into primitives too
const NON_MCQ_MAP = {
  flashcard_assess: FlashcardAssess,
  memory_match: MemoryMatch,
  word_scramble: WordScramble,
  fill_in_blank: FillInBlank,
};

/**
 * Dispatcher: primary dispatch on round_data.ui_kind (mcq/self_assess/dnd_pairs/
 * dnd_order/typing). Falls back to legacy game_type mapping for sessions built
 * before the ui_kind field existed.
 */
export default function GameRenderer({ roundData, onAnswer, palette, disabled }) {
  const props = { roundData, onAnswer, palette, disabled };

  // Primary: dispatch by ui_kind (new canonical field)
  if (roundData?.ui_kind === 'mcq') {
    return <MCQGame {...props} />;
  }

  // Non-MCQ: dispatch by game_type (Phase 2 target for further unification)
  const GameComponent = NON_MCQ_MAP[roundData?.game_type];
  if (GameComponent) {
    return <GameComponent {...props} />;
  }

  // Legacy / unknown → safe MCQ fallback
  return <MCQGame {...props} />;
}
